import { render, staticRenderFns } from "./MollieDetails.vue?vue&type=template&id=2c57573a&"
import script from "./MollieDetails.vue?vue&type=script&lang=js&"
export * from "./MollieDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c57573a')) {
      api.createRecord('2c57573a', component.options)
    } else {
      api.reload('2c57573a', component.options)
    }
    module.hot.accept("./MollieDetails.vue?vue&type=template&id=2c57573a&", function () {
      api.rerender('2c57573a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/MollieDetails.vue"
export default component.exports